import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NotificationsService } from 'angular2-notifications';
import { smoothlyMenu } from '../../../app.helpers';
import { AuthService } from '../../../auth/auth.service';
import { IUserProfileClaim, LoggedInUser, LoggedInUserService } from '../../../auth/logged.in.user';
import { Configuration } from '../../../configuration';
import { GetAccountDetailsDto, GetEmailPreferencesDto } from '../../../models/account/account.models';
import { AdvertDto, BannerAdvertDto, ConsultationsConfigDto } from '../../../models/adverts/advert.models';
import { CmsDialogDto } from '../../../models/cms.dialogs/cms.dialogs.models';
import { AccountService } from '../../../services/account.service';
import { CmsDialogService } from '../../../services/cms.dialog.service';
import { MatchingAdvertService } from '../../../services/matching.advert.service';
import { RouterService } from '../../../services/routerService';
import { SubscriptionService } from '../../../services/subscription.service';
import { SubscriptionSearchModel } from '../../../models/subscriptions/subscription.search.models';

@Component({
    selector: 'topnavbar',
    template: require('./topnavbar.component.html'),
    styles: [require('./topnavbar.component.css')]
})
export class TopNavBarComponent implements OnInit, AfterViewInit {
    user: LoggedInUser;
    currentProfile: IUserProfileClaim;
    numAdverts: number = null;
    adverts: AdvertDto[];
    bannerAd: BannerAdvertDto;
    showConsultationButton: boolean;

    dialogHeader: string;
    dialogBody: string;

    weeklyAlertHeader: string;
    weeklyAlertBody: string;
    
    scrollPosition: number = 0;
    lastScrollPosition: number = null;
    isNavbarVisible: boolean = true;

    minimumDesktopResolution: number = 1024;
    subscribed: boolean;
    preferences: GetEmailPreferencesDto;
    supplierStatus: string;
    displayBanner: boolean;
    displayConsultation: boolean;
    buttonText: string;
    blurb: string;

    isBidManager: boolean;
    publicFacingUrl: string;
    bidManagementUrl: string;
    isUserMenuOpen: boolean = false;
    isNotificationsOpen: boolean = false;
    isSectionsOpen: boolean = false;
    companyName: string;
    showSubscribeNow = false;
    subscribeNowLink: any[] = ['/account/subscribe'];
    subscribeNowQueryParams: { [key: string]: string } | null = null;

    private readonly subExpiredModalKey = 'subscriptionExpiredModalViewed';
    private readonly displayBannerKey = 'displayBanner';
    private readonly displayConsultationKey = 'displayConsultation';

    constructor(private routerService: RouterService, loggedInUserService: LoggedInUserService, private router: Router, private authService: AuthService,
        private matchingAdvertService: MatchingAdvertService, private notificationsService: NotificationsService, private readonly cmsDialogService: CmsDialogService,
        private readonly accountService: AccountService, private readonly config: Configuration, private readonly sanitizer: DomSanitizer,
        private readonly subscriptionService: SubscriptionService) {
            this.supplierStatus = '';
            this.user = loggedInUserService.getCurrentUser();
            this.publicFacingUrl = config.routing.publicFacingUrl;
            this.bidManagementUrl = config.routing.bidManagementUrl;

            if (this.user != null) {

                this.subscribed = !this.user.canAdHoc('notSubscribed');
                this.isBidManager = this.user.canAdHoc('bidManagerDashboard');

                if (this.subscribed) {
                    if (this.teamMember()) {
                        this.supplierStatus = 'Team member';
                    }
                    else {
                        this.supplierStatus = 'Tender Manager';
                    }

                    const displayBannerStorage = localStorage.getItem(this.displayBannerKey);

                    if (this.user && displayBannerStorage == 'false') {
                        this.displayBanner = false;
                    }
                    else {
                        this.displayBanner = true;
                    }

                    this.displayConsultation = false;
                }
                else {
                    this.supplierStatus = 'Free';
                    this.displayBanner = true;

                    const displayConsultationStorage = localStorage.getItem(this.displayConsultationKey);

                    if (this.user && displayConsultationStorage == 'false') {
                        this.displayConsultation = false;
                    }
                    else {
                        this.displayConsultation = true;
                    }
                    }
                }

                router.events.subscribe((val) => {
                this.isSectionsOpen = false;
                if(!this.isDesktopMode()) {
                    $('body').removeClass('mini-navbar');
                    $('.sidebar-nav-fullscreen-close').removeClass('active');
                    smoothlyMenu();
                }
            });

        this.RefreshAdverts();
        this.preferences = new GetEmailPreferencesDto();
    }

    ngOnInit() {
        if (this.user != null) {
            this.accountService.getAccountDetails().subscribe((result: GetAccountDetailsDto) => {
                this.companyName = result.companyName;
            });
        }

        this.cmsDialogService.getByDescription('Subscription Expired').subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
        });

        this.cmsDialogService.getByDescription('WeeklyAlerts').subscribe((result: CmsDialogDto) => {
            this.weeklyAlertHeader = result.header;
            this.weeklyAlertBody = result.body;

            this.accountService.getEmailPreferences().subscribe((result: GetEmailPreferencesDto) => {
                this.preferences = result;
                if (!this.subscribed && this.preferences.cumulativeAlerts) {
                    $('#weekly-alerts-modal').modal();
                }
            });
        });

        //this.accountService.isBidManager().subscribe((response: boolean) => {
        //    this.isBidManager = response;
        //});

        this.refreshSubscribeNowVisibility();

        this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
            this.refreshSubscribeNowVisibility();
        });
    }

    private refreshSubscribeNowVisibility() {
        if (!this.user) {
            this.showSubscribeNow = false;
            return;
        }

        if (this.user.canAdHoc('notSubscribed')) {
            this.showSubscribeNow = true;
            this.subscribeNowLink = ['/account/subscribe'];
            this.subscribeNowQueryParams = null;
            return;
        }

        const request = new SubscriptionSearchModel(this.config);
        request.customerId = this.user.userId;
        request.sortProperty = 'ExpiryDate';
        request.descending = true;

        this.subscriptionService.search(request).subscribe(
            (results) => {
                const pending = (results && results.data ? results.data : []).filter(
                    (s) => (s.subscriptionStatus || '').toLowerCase() === 'pending'
                );

                if (pending.length === 0) {
                    this.showSubscribeNow = false;
                    this.subscribeNowQueryParams = null;
                    return;
                }

                this.showSubscribeNow = true;
                if (pending.length === 1) {
                    this.subscribeNowLink = ['/account/subscribe', pending[0].id];
                    this.subscribeNowQueryParams = { pay: 'card' };
                } else {
                    this.subscribeNowLink = ['/account/subscriptions'];
                    this.subscribeNowQueryParams = null;
                }
            },
            () => {
                this.showSubscribeNow = false;
            }
        );
    }

    private RefreshAdverts() {
        this.matchingAdvertService.search(this.user.supplierId).subscribe((res: AdvertDto[]) => {
            this.adverts = res || [];
            var unreadAdverts = 0;
            for (var i = 0; i < this.adverts.length; i++) {
                if (!this.adverts[i].isRead) {
                    unreadAdverts++;
                }
            }
            this.numAdverts = unreadAdverts;
            if (this.numAdverts == 0) {
                this.numAdverts = null;
            }
        });

        this.subscribed = !this.user.canAdHoc('notSubscribed');

        this.matchingAdvertService.getBanner(this.subscribed).subscribe((res: BannerAdvertDto) => {
            this.bannerAd = res;
        });

        this.showConsultationButton = false;

        if (!this.subscribed) {
            this.matchingAdvertService.showConsultationButton(this.user.supplierId).subscribe((res: ConsultationsConfigDto) => {
                if (res.buttonText != null) {
                    this.showConsultationButton = true;
                    this.buttonText = res.buttonText;
                    this.blurb = res.blurb;
                }                
            });
        }

        this.refreshSubscribeNowVisibility();
    }

    private openNotifications() {
        this.matchingAdvertService.search(this.user.supplierId).subscribe((res: AdvertDto[]) => {
            this.adverts = res || [];
            const unread = this.adverts.filter(a => !a.isRead);

            if (unread.length === 0) {
                this.numAdverts = null;
                return;
            }

            forkJoin(unread.map(a => this.matchingAdvertService.markRead(a.id))).subscribe(() => {
                unread.forEach(a => a.isRead = true);
                this.numAdverts = null;
            });
        });
    }

    @HostListener("window:scroll", ['$event'])
    onWindowScroll(e) {
        this.scrollPosition = e.pageY;
        if(this.lastScrollPosition === null || this.scrollPosition < this.lastScrollPosition) {
            this.isNavbarVisible = true;
        }else{
            this.isNavbarVisible = false;
        }
        this.lastScrollPosition = e.pageY;
    }

    @HostListener('document:click')
    onDocumentClick() {
        this.isUserMenuOpen = false;
        this.isNotificationsOpen = false;
        this.isSectionsOpen = false;
    }

    toggleUserMenu(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isNotificationsOpen = false;
        this.isSectionsOpen = false;
        this.isUserMenuOpen = !this.isUserMenuOpen;
    }

    toggleSections(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isUserMenuOpen = false;
        this.isNotificationsOpen = false;
        this.isSectionsOpen = !this.isSectionsOpen;
    }

    onSectionNavClick() {
        this.isSectionsOpen = false;
        this.isUserMenuOpen = false;
        this.isNotificationsOpen = false;
        if (!this.isDesktopMode()) {
            $('body').removeClass('mini-navbar');
            $('.sidebar-nav-fullscreen-close').removeClass('active');
            smoothlyMenu();
        }
    }

    onSubscribeNowClick(event: MouseEvent, fromSections: boolean = false) {
        if (fromSections) {
            this.onSectionNavClick();
        } else {
            this.isUserMenuOpen = false;
            this.isNotificationsOpen = false;
        }

        if (!this.shouldResetSubscribePage()) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        this.router.navigate(['/account/subscribe'], {
            queryParams: {
                resetCheckout: Date.now().toString()
            }
        });
    }

    private shouldResetSubscribePage(): boolean {
        const currentPath = (this.router.url || '').split('?')[0];
        const isBaseSubscribeLink =
            this.subscribeNowLink &&
            this.subscribeNowLink.length === 1 &&
            this.subscribeNowLink[0] === '/account/subscribe';

        return currentPath === '/account/subscribe' &&
            isBaseSubscribeLink &&
            (!this.subscribeNowQueryParams || Object.keys(this.subscribeNowQueryParams).length === 0);
    }

    toggleNotifications(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isUserMenuOpen = false;
        this.isSectionsOpen = false;
        this.isNotificationsOpen = !this.isNotificationsOpen;
        if (this.isNotificationsOpen) {
            this.openNotifications();
        }
    }

    dismissAdvert(id: number, event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.matchingAdvertService.remove(id).subscribe(() => {
            this.RefreshAdverts();
        });
    }

    getAdvertPreviewHtml(advert: AdvertDto): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(advert.content || '');
    }

    hasNotificationLink(advert: AdvertDto): boolean {
        return !!(advert.link && advert.link.trim().length > 0);
    }

    isDesktopMode(): boolean {
        return window.innerWidth > this.minimumDesktopResolution;
    }

    ngAfterViewInit() {
        $('#side-menu').metisMenu();

        const modalViewed = localStorage.getItem(this.subExpiredModalKey);

        if (this.user && this.user.subscriptionExpired && !modalViewed) {
            $('#subscription-expired-modal').modal();
        }
    }

    toggleNavigation(): void {
        $('.sidebar-nav-fullscreen-close').toggleClass('active');
        $('body').toggleClass('mini-navbar');
        smoothlyMenu();

        // Toggle icon between fa-chevron-left and fa-chevron-right
        const icon = $('.minimalize-styl-2 i');
        icon.toggleClass('fa-chevron-left fa-chevron-right');
    }

    subscriptionExpiredModalViewed() {
        localStorage.setItem(this.subExpiredModalKey, 'true');
    }

    weeklyAlertsModalViewed() {
        //localStorage.setItem(this.subExpiredModalKey, 'true');
    }

    archive() {
        $('#weekly-alerts-modal').modal('hide');
        $('#subscription-expired-modal').modal('hide');
        $('#confirm-removal-modal').modal();
    }

    confirmArchive() {
        $('#confirm-removal-modal').modal('hide');

        this.accountService.archive().subscribe((result: boolean) => {
            if (result) {
                this.notificationsService.success('Success',
                    'Your account will be Removed from our system within the next 24 hours.');
            }
        });        
    }

    logout() {
        this.authService.logout();
    }

    viewAccountDetails() {
        this.routerService.router.navigateByUrl(`/viewAccount`);
    }

    teamMember(): boolean {
        return (this.user.role != 'Supplier');
    }

    closeBanner() {
        this.displayBanner = false;
        localStorage.setItem(this.displayBannerKey, 'false');
    }

    closeConsultation() {
        this.displayConsultation = false;
        localStorage.setItem(this.displayConsultationKey, 'false');
    }

    recordConsultationClick() {
        this.accountService.recordConsultationClick().subscribe((response: any) => {
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/topnavbar/topnavbar.component.ts